export default __webpack_public_path__ + "static/media/money-back@3x.d1a38046.png";